/**
 * Basic object guard. It matches any object, including arrays and functions
 */ export const isObject = (term)=>{
    return term !== null && typeof term === 'object';
};
